module.exports = __webpack_public_path__ + "img/W+.906f1763.png";